import { canvasSelectableFromG6Id } from 'dashboard/components/GraphCanvasV2/G6Mapper';
import { Layer } from 'dashboard/components/GraphCanvasV2/layers/layer';
import CanvasEdgeTarget, {
  CanvasEdge,
} from 'dashboard/components/GraphCanvasV2/target/canvas-edge-target';

export default class CanvasEdgeLayer extends Layer implements Iterable<CanvasEdgeTarget> {
  public [Symbol.iterator](): Iterator<CanvasEdgeTarget, null> {
    // Seed with relevant nodes
    let worldPoint;
    let g6Edges;
    const edges: CanvasEdge[] = [];
    try {
      worldPoint = this.g6Wrapper.getPointByCanvas(this.canvasX, this.canvasY);
      g6Edges = this.g6Wrapper.findEdgesAtPosition(worldPoint.x, worldPoint.y);
      for (const g6Edge of g6Edges) {
        const source = canvasSelectableFromG6Id(g6Edge.getSource().getID());
        const target = canvasSelectableFromG6Id(g6Edge.getSource().getID());

        if (source && target) {
          edges.push({
            source,
            target,
          });
        }
      }
    } catch (e) {
      return {
        next: function () {
          return { value: null as null, done: true };
        },
      };
    }

    return {
      next: function () {
        const edge = edges.shift();

        const result: IteratorResult<CanvasEdgeTarget, null> = edge
          ? {
              value: new CanvasEdgeTarget(edge),
              done: false,
            }
          : {
              value: null,
              done: true,
            };

        return result;
      }.bind(this),
    };
  }
}
